import * as React from 'react';
import ThirdPartyInfiniteScroll from 'react-infinite-scroll-component';
import { Skeleton } from '@material-ui/lab';
import { Placeholder } from '../Utils';
import { border } from '@topconagriculture/theme';
import { useTheme } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core';
const useStyle = makeStyles((theme) => ({
    scrollContainer: {
        height: ({ hasData }) => (hasData ? 'auto' : '100%'),
        '& .infinite-scroll-component__outerdiv': {
            height: '100%',
        },
    },
}));
export const InfiniteScroll = (props) => {
    const { loader, data = [], noDataComponent, itemComponent: ItemComponent, hasMore, itemKey = 'id', defaultLoaderCount = 10, defaultLoaderHeight = 40, noDataProps = { title: 'No data found', iconName: 'close2', small: true }, testId = 'InfiniteScroll', ...innerProps } = props;
    const theme = useTheme();
    const LoaderComponent = loader ||
        new Array(defaultLoaderCount)
            .fill(null)
            .map((value, index) => (React.createElement(Skeleton, { key: index, variant: 'rect', height: defaultLoaderHeight, style: { borderBottom: border(theme.color.grey.light) } })));
    const EmptyComponent = noDataComponent || React.createElement(Placeholder, Object.assign({}, noDataProps));
    const endMessage = !data.length && !hasMore && EmptyComponent;
    const classes = useStyle({ hasData: !!data.length });
    const style = innerProps.scrollableTarget ? { overflow: 'hidden', height: '100%' } : undefined;
    return (React.createElement("div", { className: classes.scrollContainer, "data-testid": `${testId}-dataPath` },
        React.createElement(ThirdPartyInfiniteScroll, Object.assign({ endMessage: endMessage, hasMore: hasMore, dataLength: data.length, loader: LoaderComponent, style: style }, innerProps), data.map((item) => (React.createElement(ItemComponent, { key: item[itemKey], item: item }))))));
};
//# sourceMappingURL=InfiniteScroll.js.map